import React, { useEffect } from 'react';
import is from 'is_js';
// import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Chart as ChartJS, registerables } from 'chart.js';
import { CloseButton } from 'components/common/Toast';
// import SettingsToggle from 'components/settings-panel/SettingsToggle';
// import SettingsPanel from 'components/settings-panel/SettingsPanel';
import { useAppContext } from 'providers/AppProvider';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import DSAssessment from 'components/pages/dsassessment';
import useOrientation from './useOrientation';
import { useMediaQuery } from 'react-responsive';


ChartJS.register(...registerables);

const App = () => {

  const orientation = useOrientation();
  const isPortrait = orientation === 'portrait';
  const isMobile = useMediaQuery({ maxWidth: 320 });

  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const {
    config: { navbarPosition }
  } = useAppContext();

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
    if (is.safari()) {
      HTMLClassList.add('safari');
    }
  }, [HTMLClassList]);

  useEffect(() => {
    if (navbarPosition === 'double-top') {
      HTMLClassList.add('double-top-nav-layout');
    }
    return () => HTMLClassList.remove('double-top-nav-layout');
  }, [navbarPosition]);

  return (
    <>
    <div>
      {/* Main application content */}
      {/* A custom modal or message can be displayed if not in the desired orientation */}
      {isPortrait && isMobile && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          color: 'white',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
          textAlign: 'center',
          padding: '20px'
        }}>
          <h2 className="text-danger">Please rotate your device to landscape mode for the best experience.</h2>
        </div>
      )}
      {/* Rest of your app components */}
      <DSAssessment />
      {/* <h1>Current orientation: {orientation}</h1> */}
    </div>
      {/* <Outlet /> */}
      {/* <DSAssessment /> */}
      {/* <SettingsToggle /> */}
      {/* <SettingsPanel /> */}
      <ToastContainer
        closeButton={CloseButton}
        icon={false}
        position="bottom-left"
      />
    </>
  );
};

export default App;
